import React from 'react'
import { TextField } from '@mui/material'
function ReadOnlyTextField({ value }) {
    return (
        <div style={{maxWidth:'100%',width:'-webkit-fill-available', margin:"0 0.2rem"}}>
            <TextField
                id="outlined-read-only-input"
                // label="Read Only"
                defaultValue={value}
                InputProps={{
                    readOnly: true,
                }}
                variant="outlined"
                fullWidth
                size='small'
                sx={{maxWidth:'100%',width:'-webkit-fill-available'}}
            />
        </div>
    )
}

export default ReadOnlyTextField;